import ReactGA from 'react-ga4';
import { trackMetaEvent } from './eventTrackMeta';

// Function helper untuk tracking
const trackEvent = (eventName, params = {}) => {
    ReactGA.event(eventName, params);
};

const trackRegistWaiver = (params) => {
    trackEvent('sign_up', params);
    trackMetaEvent('CompleteRegistration', params);
};
const trackSignIn = (params) => {
    trackEvent('login', params);
    trackMetaEvent('Contact', params); // Or custom 'Login'
};
const trackDetailItem = (params) => {
    trackEvent('view_item', params);
    trackMetaEvent('ViewContent', params);
};
const trackAddToCart = (params) => {
    trackEvent('add_to_cart', params);
    trackMetaEvent('AddToCart', params);
};
const trackRemoveFromCart = (params) => {
    trackEvent('remove_from_cart', params);
    trackMetaEvent('CustomEvent', { ...params, event: 'remove_from_cart' });
};
const trackCheckout = (params) => {
    trackEvent('begin_checkout', params);
    trackMetaEvent('InitiateCheckout', params);
};
const trackPaymentInfo = (params) => {
    trackEvent('add_payment_info', params);
    trackMetaEvent('AddPaymentInfo', params);
};
const trackPurchase = (params) => {
    trackEvent('purchase', params);
    trackMetaEvent('Purchase', {
        value: params.value || params.revenue,
        currency: params.currency || 'IDR',
        content_ids: params.items?.map((item) => item.item_id || item.id),
        content_type: 'product',
        ...params,
    });
};
const trackStayMoreThan5Sec = () => {
    // Timer untuk mendeteksi apakah user bertahan > 5 detik
    const timer = setTimeout(() => {
        ReactGA.event('stay_more_than_5s', {
            engagement_time: 5000,
            page_path: window.location.pathname,
        });
    }, 5000);

    return timer;
};
const trackUserChangePage = (pathname = '/') => {
    // Lacak setiap perpindahan halaman
    ReactGA.send({ hitType: 'pageview', page: pathname });
};
const trackQuickBouncePage = (pathname = '/') => {
    ReactGA.event('stay_more_than_5s', {
        page_path: pathname,
        engagement_time: 5000,
    });
};

export { trackAddToCart, trackCheckout, trackDetailItem, trackEvent, trackPaymentInfo, trackPurchase, trackQuickBouncePage, trackRegistWaiver, trackRemoveFromCart, trackSignIn, trackStayMoreThan5Sec, trackUserChangePage };

